import Vue from 'vue'
import Router from 'vue-router'
import Spanish from './views/Spanish.vue'
import English from './views/English.vue'
import Italian from './views/Italian.vue'
Vue.use(Router)

export default new Router({
   mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Spanish
    },
     {
      path: '/en',
      name: 'en',
      component: English
    },
     {
      path: '/es',
      name: 'es',
      component: Spanish
    },
     {
      path: '/it',
      name: 'it',
      component: Italian
    }
  ]
})
